<template>
    <span v-show="show" class="a-form-inputs--error"><slot></slot></span>
</template>

<script>
    export default {
        name: 'control-error',
        props: {
            show: {
                type: Boolean,
                default: true
            },
        },
    }
</script>


// WEBPACK FOOTER //
// Error.vue?6391a732